import { COLORS } from '@/config/colors';
import { css, fillOutlined, circle, roundedPoly, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const STEEL = 0x4a4a58; // weathered bunker plating
const VISOR = 0xd92b2b;

/**
 * Space bunker — stationary wave turret (docs/12 wave variety request).
 * Hex pillbox with four gun nubs and a tracking visor core.
 * Frame 0 idle / 1 visor charge blink. Barrel points +X.
 */
export const minionBunker: ProceduralDef = {
  key: 'minion/bunker',
  width: 80,
  height: 80,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const charging = frame === 1;

    // Foundation slab — slightly larger dark hex (sits ON the floor)
    const hex = (r: number): void => {
      ctx.beginPath();
      for (let i = 0; i < 6; i++) {
        const a = (Math.PI / 3) * i + Math.PI / 6;
        const px = c + Math.cos(a) * r;
        const py = c + Math.sin(a) * r;
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      }
      ctx.closePath();
    };
    hex(34);
    fillOutlined(ctx, shade(STEEL, 0.55), 5);

    // Armored dome
    hex(26);
    fillOutlined(ctx, STEEL, 5);

    // Plate rivets
    ctx.fillStyle = css(shade(STEEL, 0.7));
    for (let i = 0; i < 6; i++) {
      const a = (Math.PI / 3) * i + Math.PI / 6;
      circle(ctx, c + Math.cos(a) * 20, c + Math.sin(a) * 20, 2.5);
      ctx.fill();
    }

    // Main barrel (+X) + three stub nubs
    roundedPoly(ctx, [[c + 22, c - 5], [c + 38, c - 4], [c + 38, c + 4], [c + 22, c + 5]], 2);
    fillOutlined(ctx, shade(STEEL, 0.8), 4);
    for (const a of [Math.PI / 2, Math.PI, -Math.PI / 2]) {
      const bx = c + Math.cos(a) * 24;
      const by = c + Math.sin(a) * 24;
      circle(ctx, bx, by, 4.5);
      fillOutlined(ctx, shade(STEEL, 0.8), 3);
    }

    // Tracking visor core
    circle(ctx, c, c, charging ? 11 : 9);
    fillOutlined(ctx, charging ? COLORS.dangerOrange : VISOR, 3.5);
    circle(ctx, c + 2.5, c - 2.5, 2.5);
    ctx.fillStyle = 'rgba(255,255,255,0.9)';
    ctx.fill();
    if (charging) {
      circle(ctx, c, c, 16);
      ctx.fillStyle = 'rgba(232, 84, 47, 0.25)';
      ctx.fill();
    }
    void h;
  },
};
